const data = 
[
    {
        "brand": "Sony",
        "camera": "RX100 Ⅶ",
        "controlFunction": "Bluetooth",
        "photo": "√",
        "video": "√",
        "blueToothTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "√",
        "focus": "×",
        "zoom": "×",
        "cameraFirmware": "1.00",
        "blueToothFirmware": "Bluetooth_V103",
        "note": "1.How to set up the camera's bluetooth:\n-MENU→Network1→Bluetooth Settings→Bluetooth Function→On\n-Network2→Bluetooth Rmt Ctrl→On\n-Network1→Bluetooth Settings→Pairing\n2.Gimbal operation: Swipt left from the main interface →Bluetooth setting→turn on camera control button→click the camera name to pairing\n3.Please switch photo / video mode on camera manually."
    },
    {
        "brand": "Sony",
        "camera": "A6100",
        "controlFunction": "Bluetooth",
        "photo": "√",
        "video": "√",
        "blueToothTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "√",
        "focus": "×",
        "zoom": "×",
        "cameraFirmware": "1.00",
        "blueToothFirmware": "Bluetooth_V104",
        "note": "1.How to set up the camera's bluetooth:\n-MENU→Network→Bluetooth Settings→Bluetooth Function→On\n-Network→Bluetooth Rmt Ctrl→On\n-Network→Bluetooth Settings→Pairing\n2.Gimbal operation: Swipt left from the main interface →Bluetooth setting→turn on camera control button→click the camera name to pairing\n3.Due to limitations of some camera systems, camera control cannot be achieved in only Bluetooth pairing state. You must also ensure that the Bluetooth remote control is on.\n4.Since the Bluetooth shutter has a higher priority,if adjust camera parameters such as aperture,shutter,ISO by connecting with shutter release cable.Please make sure bluetooth is disconnected .\n5.Please switch photo / video mode on camera manually."
    },
    {
        "brand": "Sony",
        "camera": "A6400",
        "controlFunction": "Bluetooth",
        "photo": "√",
        "video": "√",
        "blueToothTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "√",
        "focus": "×",
        "zoom": "×",
        "cameraFirmware": "2.00",
        "blueToothFirmware": "Bluetooth_V104",
        "note": "1.How to set up the camera's bluetooth:\n-MENU→Network→Bluetooth Settings→Bluetooth Function→On\n-Network→Bluetooth Rmt Ctrl→On\n-Network→Bluetooth Settings→Pairing\n2.Gimbal operation: Swipt left from the main interface →Bluetooth setting→turn on camera control button→click the camera name to pairing\n3.Due to limitations of some camera systems, camera control cannot be achieved in only Bluetooth pairing state. You must also ensure that the Bluetooth remote control is on.\n4.Since the Bluetooth shutter has a higher priority,if adjust camera parameters such as aperture,shutter,ISO by connecting with shutter release cable.Please make sure bluetooth is disconnected .\n5.Please switch photo / video mode on camera manually."
    },
    {
        "brand": "Sony",
        "camera": "A6700",
        "controlFunction": "Bluetooth",
        "photo": "√",
        "video": "√",
        "blueToothTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "√",
        "focus": "×",
        "zoom": "×",
        "cameraFirmware": "1.00",
        "blueToothFirmware": "Bluetooth_V103",
        "note": "1.How to set up the camera's bluetooth:\n-MENU→Network→Bluetooth Settings→Bluetooth Function→On\n-Network→Bluetooth Rmt Ctrl→On\n-Network→Bluetooth Settings→Pairing\n2.Gimbal operation: Swipt left from the main interface →Bluetooth setting→turn on camera control button→click the camera name to pairing\n3.Due to limitations of some camera systems, camera control cannot be achieved in only Bluetooth pairing state. You must also ensure that the Bluetooth remote control is on.\n4.Since the Bluetooth shutter has a higher priority,if adjust camera parameters such as aperture,shutter,ISO by connecting with shutter release cable.Please make sure bluetooth is disconnected .\n5.Please switch photo / video mode on camera manually."
    },
    {
        "brand": "Sony",
        "camera": "ZV-1M2",
        "controlFunction": "Bluetooth",
        "photo": "√",
        "video": "√",
        "blueToothTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "√",
        "focus": "×",
        "zoom": "×",
        "cameraFirmware": "1.00",
        "blueToothFirmware": "Bluetooth_V103",
        "note": "1.How to set up the camera's bluetooth:\n-MENU→Network→Bluetooth Settings→Bluetooth Function→On\n-Network→Bluetooth Rmt Ctrl→On\n-Network→Bluetooth Settings→Pairing\n2.Gimbal operation: Swipt left from the main interface →Bluetooth setting→turn on camera control button→click the camera name to pairing\n3.Due to limitations of some camera systems, camera control cannot be achieved in only Bluetooth pairing state. You must also ensure that the Bluetooth remote control is on.\n4.Since the Bluetooth shutter has a higher priority,if adjust camera parameters such as aperture,shutter,ISO by connecting with shutter release cable.Please make sure bluetooth is disconnected .\n5.Please switch photo / video mode on camera manually."
    },
    {
        "brand": "Sony",
        "camera": "A7C Ⅱ",
        "controlFunction": "Bluetooth",
        "photo": "√",
        "video": "√",
        "blueToothTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "√",
        "focus": "×",
        "zoom": "×",
        "cameraFirmware": "1.00",
        "blueToothFirmware": "Bluetooth_V104",
        "note": "1.How to set up the camera's bluetooth:\n-MENU→Network→Bluetooth Settings→Bluetooth Function→On\n-Network→Bluetooth Rmt Ctrl→On\n-Network→Bluetooth Settings→Pairing\n2.Gimbal operation: Swipt left from the main interface →Bluetooth setting→turn on camera control button→click the camera name to pairing\n3.Due to limitations of some camera systems, camera control cannot be achieved in only Bluetooth pairing state. You must also ensure that the Bluetooth remote control is on.\n4.Since the Bluetooth shutter has a higher priority,if adjust camera parameters such as aperture,shutter,ISO by connecting with shutter release cable.Please make sure bluetooth is disconnected .\n5.Please switch photo / video mode on camera manually."
    },
    {
        "brand": "Sony",
        "camera": "A7R V",
        "controlFunction": "Bluetooth",
        "photo": "√",
        "video": "√",
        "blueToothTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "√",
        "focus": "×",
        "zoom": "×",
        "cameraFirmware": "1.00",
        "blueToothFirmware": "Bluetooth_V104",
        "note": "1.How to set up the camera's bluetooth:\n-MENU→Network→Bluetooth Settings→Bluetooth Function→On\n-Network→Bluetooth Rmt Ctrl→On\n-Network→Bluetooth Settings→Pairing\n2.Gimbal operation: Swipt left from the main interface →Bluetooth setting→turn on camera control button→click the camera name to pairing\n3.Due to limitations of some camera systems, camera control cannot be achieved in only Bluetooth pairing state. You must also ensure that the Bluetooth remote control is on.\n4.Since the Bluetooth shutter has a higher priority,if adjust camera parameters such as aperture,shutter,ISO by connecting with shutter release cable.Please make sure bluetooth is disconnected .\n5.Please switch photo / video mode on camera manually."
    },
    {
        "brand": "Sony",
        "camera": "A7S Ⅲ",
        "controlFunction": "Bluetooth",
        "photo": "√",
        "video": "√",
        "blueToothTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "√",
        "focus": "×",
        "zoom": "×",
        "cameraFirmware": "2.10",
        "blueToothFirmware": "Bluetooth_V103",
        "note": "1.How to set up the camera's bluetooth:\n-MENU→Network→Bluetooth Settings→Bluetooth Function→On\n-Network→Bluetooth Rmt Ctrl→On\n-Network→Bluetooth Settings→Pairing\n2.Gimbal operation: Swipt left from the main interface →Bluetooth setting→turn on camera control button→click the camera name to pairing\n3.Due to limitations of some camera systems, camera control cannot be achieved in only Bluetooth pairing state. You must also ensure that the Bluetooth remote control is on.\n4.Since the Bluetooth shutter has a higher priority,if adjust camera parameters such as aperture,shutter,ISO by connecting with shutter release cable.Please make sure bluetooth is disconnected .\n5.Please switch photo / video mode on camera manually."
    },
    {
        "brand": "Sony",
        "camera": "ZV-1",
        "controlFunction": "Bluetooth",
        "photo": "√",
        "video": "√",
        "blueToothTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "√",
        "focus": "×",
        "zoom": "×",
        "cameraFirmware": 2.01,
        "blueToothFirmware": "Bluetooth_V105",
        "note": "1.How to set up the camera's bluetooth:\n-MENU→Network→Bluetooth Settings→Bluetooth Function→On\n-Network→Bluetooth Rmt Ctrl→On\n-Network→Bluetooth Settings→Pairing\n2.Gimbal operation: Swipt left from the main interface →Bluetooth setting→turn on camera control button→click the camera name to pairing\n3.Due to limitations of some camera systems, camera control cannot be achieved in only Bluetooth pairing state. You must also ensure that the Bluetooth remote control is on.\n4.Since the Bluetooth shutter has a higher priority,if adjust camera parameters such as aperture,shutter,ISO by connecting with shutter release cable.Please make sure bluetooth is disconnected .\n5.Please switch photo / video mode on camera manually."
    },
    {
        "brand": "Sony",
        "camera": "A7C",
        "controlFunction": "Bluetooth",
        "photo": "√",
        "video": "√",
        "blueToothTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "√",
        "focus": "×",
        "zoom": "×",
        "cameraFirmware": "2.00",
        "blueToothFirmware": "Bluetooth_V105",
        "note": "1.How to set up the camera's bluetooth:\n-MENU→Network→Bluetooth Settings→Bluetooth Function→On\n-Network→Bluetooth Rmt Ctrl→On\n-Network→Bluetooth Settings→Pairing\n2.Gimbal operation: Swipt left from the main interface →Bluetooth setting→turn on camera control button→click the camera name to pairing\n3.Due to limitations of some camera systems, camera control cannot be achieved in only Bluetooth pairing state. You must also ensure that the Bluetooth remote control is on.\n4.Since the Bluetooth shutter has a higher priority,if adjust camera parameters such as aperture,shutter,ISO by connecting with shutter release cable.Please make sure bluetooth is disconnected .\n5.Please switch photo / video mode on camera manually."
    },
    {
        "brand": "Sony",
        "camera": "A7R Ⅳ",
        "controlFunction": "Bluetooth",
        "photo": "√",
        "video": "√",
        "blueToothTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "√",
        "focus": "×",
        "zoom": "×",
        "cameraFirmware": "1.20",
        "blueToothFirmware": "Bluetooth_V105",
        "note": "1.How to set up the camera's bluetooth:\n-MENU→Network→Bluetooth Settings→Bluetooth Function→On\n-Network→Bluetooth Rmt Ctrl→On\n-Network→Bluetooth Settings→Pairing\n2.Gimbal operation: Swipt left from the main interface →Bluetooth setting→turn on camera control button→click the camera name to pairing\n3.Due to limitations of some camera systems, camera control cannot be achieved in only Bluetooth pairing state. You must also ensure that the Bluetooth remote control is on.\n4.Since the Bluetooth shutter has a higher priority,if adjust camera parameters such as aperture,shutter,ISO by connecting with shutter release cable.Please make sure bluetooth is disconnected .\n5.Please switch photo / video mode on camera manually."
    },
    {
        "brand": "Sony",
        "camera": "A7 IV",
        "controlFunction": "Bluetooth",
        "photo": "√",
        "video": "√",
        "blueToothTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "√",
        "focus": "×",
        "zoom": "×",
        "cameraFirmware": "2.00",
        "blueToothFirmware": "Bluetooth_V105",
        "note": "1.How to set up the camera's bluetooth:\n-MENU→Network→Bluetooth Settings→Bluetooth Function→On\n-Network→Bluetooth Rmt Ctrl→On\n-Network→Bluetooth Settings→Pairing\n2.Gimbal operation: Swipt left from the main interface →Bluetooth setting→turn on camera control button→click the camera name to pairing\n3.Due to limitations of some camera systems, camera control cannot be achieved in only Bluetooth pairing state. You must also ensure that the Bluetooth remote control is on.\n4.Since the Bluetooth shutter has a higher priority,if adjust camera parameters such as aperture,shutter,ISO by connecting with shutter release cable.Please make sure bluetooth is disconnected .\n5.Please switch photo / video mode on camera manually."
    },
    {
        "brand": "Sony",
        "camera": "ZV-E10",
        "controlFunction": "Bluetooth",
        "photo": "√",
        "video": "√",
        "blueToothTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "√",
        "focus": "×",
        "zoom": "×",
        "cameraFirmware": "2.00",
        "blueToothFirmware": "Bluetooth_V105",
        "note": "1.How to set up the camera's bluetooth:\n-MENU→Network1→Bluetooth Settings→Bluetooth Function→On\n-Network2→Bluetooth Rmt Ctrl→On\n-Network1→Bluetooth Settings→Pairing\n2.Gimbal operation: Swipt left from the main interface →Bluetooth setting→turn on camera control button→click the camera name to pairing\n3.Please switch photo / video mode on camera manually."
    },
    {
        "brand": "Canon",
        "camera": "EOS 200D Ⅱ",
        "controlFunction": "Bluetooth",
        "photo": "√",
        "video": "√",
        "blueToothTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "√",
        "focus": "×",
        "zoom": "×",
        "cameraFirmware": "1.0.3",
        "blueToothFirmware": "Bluetooth_V104",
        "note": "1.Wireless communication settings→Bluetooth function→Remote\n2.Wireless communication settings→WiFi/Bluetooth connection→Connect to Wireless Remote→ Add a device to connect to \n3.Gimbal operation: Swipt left from the main interface →Bluetooth setting→turn on camera control button→click the camera name to pairing\n4.Switching the camera to M mode(photo mode):Single tap the Q/SET button→Drive mode→Self-timer:10 sec/remote or Self-timer:2 sec/remote\n5.Switching the camera to video mode(M):      →Remote control→Enable\n6.     →Auto power off→OFF\n7.Please switch photo / video mode on camera manually."
    },
    {
        "brand": "Canon",
        "camera": "EOS M50",
        "controlFunction": "Bluetooth",
        "photo": "√",
        "video": "√",
        "blueToothTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "√",
        "focus": "×",
        "zoom": "×",
        "cameraFirmware": "1.1.0",
        "blueToothFirmware": "Bluetooth_V103",
        "note": "1.Wireless communication settings→Bluetooth function→Remote\n2.Wireless communication settings→Bluetooth function→Pairing ( If \"Pairing\" is gray, please click \"Check/clear conection info\" below to clear Bluetooth connection, then pairing again.) \n3.Gimbal operation: Swipt left from the main interface →Bluetooth setting→turn on camera control button→click the camera name to pairing\n4.Switching the camera to M mode(photo mode):Single tap the Q/SET button→Drive mode→Self-timer:10 sec / Self-timer:2 sec\n5.Switching the camera to video mode(M):      →Remote control→Enable\n6.     →Power saving→Auto power off→Disable\n7.Please switch photo / video mode on camera manually."
    },
    {
        "brand": "Canon",
        "camera": "EOS R",
        "controlFunction": "Bluetooth",
        "photo": "√",
        "video": "√",
        "blueToothTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "√",
        "focus": "×",
        "zoom": "×",
        "cameraFirmware": "1.8.0",
        "blueToothFirmware": "Bluetooth_V103",
        "note": "1.Wireless communication settings→Bluetooth function→Remote\n2.Wireless communication settings→Bluetooth function→Pairing ( If \"Pairing\" is gray, please click \"Check/clear conection info\" below to clear Bluetooth connection, then pairing again.) \n3.Gimbal operation: Swipt left from the main interface →Bluetooth setting→turn on camera control button→click the camera name to pairing\n4.Switching the camera to M mode(photo mode):Single tap the Q/SET button→Drive mode→Self-timer:10 sec / Self-timer:2 sec\n5.Switching the camera to video mode:     →Remote control→Enable\n6.     →Power saving→Auto power off→Disable\n7.Please switch photo / video mode on camera manually."
    },
    {
        "brand": "Canon",
        "camera": "EOS R6",
        "controlFunction": "Bluetooth",
        "photo": "√",
        "video": "√",
        "blueToothTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "√",
        "focus": "×",
        "zoom": "×",
        "cameraFirmware": "1.8.2",
        "blueToothFirmware": "Bluetooth_V104",
        "note": "1.Wireless communication settings→Bluetooth settings→Enable\n2.Wireless communication settings→WiFi/Bluetooth connection→Connect to Wireless Remote \n3.Gimbal operation: Swipt left from the main interface →Bluetooth setting→turn on camera control button→click the camera name to pairing\n4.Switching the camera to M mode(photo mode):Single tap the Q button→Drive mode→Self-timer:10 sec/remote or Self-timer:2 sec/remote\n5.Switching the camera to video mode:Remote control→Enable\n6.     →Power saving→Auto power off→Disable\n7.Please switch photo / video mode on camera manually."
    },
    {
        "brand": "Canon",
        "camera": "EOS R7",
        "controlFunction": "Bluetooth",
        "photo": "√",
        "video": "√",
        "blueToothTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "√",
        "focus": "×",
        "zoom": "×",
        "cameraFirmware": "1.3.1",
        "blueToothFirmware": "Bluetooth_V104",
        "note": "1.Wireless communication settings→Bluetooth settings→Enable\n2.Wireless communication settings→WiFi/Bluetooth connection→Connect to Wireless Remote→ Add a device to connect to \n3.Gimbal operation: Swipt left from the main interface →Bluetooth setting→turn on camera control button→click the camera name to pairing\n4.Switching the camera to M mode:      →Drive mode→Self-timer:10 sec/remote or Self-timer:2sec/remote\n5.Switching the camera to video mode:Remote control→Enable\n6.Power saving→Auto power off→OFF\n7.Please switch photo / video mode on camera manually."
    },
    {
        "brand": "Canon",
        "camera": "EOS R10",
        "controlFunction": "Bluetooth",
        "photo": "√",
        "video": "√",
        "blueToothTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "√",
        "focus": "×",
        "zoom": "×",
        "cameraFirmware": "1.2.0",
        "blueToothFirmware": "Bluetooth_V104",
        "note": "1.Wireless communication settings→Bluetooth settings→Enable\n2.Wireless communication settings→WiFi/Bluetooth connection→Connect to Wireless Remote→ Add a device to connect to \n3.Gimbal operation: Swipt left from the main interface →Bluetooth setting→turn on camera control button→click the camera name to pairing\n4.Switching the camera to M mode(photo mode):     →Drive mode→Self-timer:10 sec or Self-timer:2 sec\n5.Switching the camera to video mode:      →Remote control→Enable\n6.     →Power saving→Auto power off→Disable\n7.Please switch photo / video mode on camera manually."
    },
    {
        "brand": "Canon",
        "camera": "EOS R50",
        "controlFunction": "Bluetooth",
        "photo": "√",
        "video": "√",
        "blueToothTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "√",
        "focus": "×",
        "zoom": "×",
        "cameraFirmware": "1.00",
        "blueToothFirmware": "Bluetooth_V104",
        "note": "1.    →Bluetooth settings→Enable\n2.Connect to Wireless Remote→Add a device to connect to \n3.Gimbal operation: Swipt left from the main interface →Bluetooth setting→turn on camera control button→click the camera name to pairing\n4.Power saving→Auto power off→Disable\n5.Please switch photo / video mode on camera manually."
    },
    {
        "brand": "Canon",
        "camera": "EOS R5C",
        "controlFunction": "Bluetooth",
        "photo": "√",
        "video": "×",
        "blueToothTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "√",
        "focus": "×",
        "zoom": "×",
        "cameraFirmware": "1.0.5.1",
        "blueToothFirmware": "Bluetooth_V105",
        "note": "1.Wireless communication settings→Bluetooth settings→Enable\n2.Wireless communication settings→Wi-Fi/Bluetooth connection→Connect to Wireless Remote→Add a device to connect to \n3.Gimbal operation: Swipt left from the main interface →Bluetooth setting→turn on camera control button→click the camera name to pairing\n4.Tap Q button →Drive mode→Self-timer:10 sec/remote or Self-timer:2 sec/remote\n5.     →Power saving→Auto power off\n6.Please make sure turn the gimbal on with Photo mode"
    },
    {
        "brand": "Canon",
        "camera": "EOS M50 Mark Ⅱ",
        "controlFunction": "Bluetooth",
        "photo": "√",
        "video": "√",
        "blueToothTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "√",
        "focus": "×",
        "zoom": "×",
        "cameraFirmware": "1.0.1",
        "blueToothFirmware": "Bluetooth_V105",
        "note": "1.Wireless settings→Bluetooth settings→Enable\n2.Wireless settings→Wi-Fi/Bluetooth connection→Connect to Wireless Remote→Add a device to connect to \n3.Gimbal operation: Swipt left from the main interface →Bluetooth setting→turn on camera control button→click the camera name to pairing\n4.Switching the camera to M mode:Shooting settings→Drive mode→Self-timer:10 sec/remote or Self-timer:2sec/remote\n5.Switching the camera to video mode:Shooting settings→Remote control→Enable\n6.Function settings→Power saving→Auto power off\n7.Please switch photo / video mode on camera manually."
    },
    {
        "brand": "Canon",
        "camera": "EOS RP",
        "controlFunction": "Bluetooth",
        "photo": "√",
        "video": "√",
        "blueToothTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "√",
        "focus": "×",
        "zoom": "×",
        "cameraFirmware": "1.6.0",
        "blueToothFirmware": "Bluetooth_V105",
        "note": "1.Wireless communication settings→Bluetooth function→Remote\n2.Wireless communication settings→Bluetooth function→Pairing ( If \"Pairing\" is gray, please click \"Check/clear conection info\" below to clear Bluetooth connection, then pairing again.) \n3.Gimbal operation: Swipt left from the main interface →Bluetooth setting→turn on camera control button→click the camera name to pairing\n4.Switching the camera to M mode(photo mode):Single tap the Q/SET button→Drive mode→Self-timer:10 sec/remote or Self-timer:2 sec/remote\n5.Switching the camera to video mode:     →Remote control→Enable\n6.     →Power saving→Auto power off\n7.Please switch photo / video mode on camera manually."
    },
    {
        "brand": "Canon",
        "camera": "Powershot G7 X Mark Ⅲ",
        "controlFunction": "Bluetooth",
        "photo": "√",
        "video": "√",
        "blueToothTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "√",
        "focus": "×",
        "zoom": "×",
        "cameraFirmware": "1.3.0",
        "blueToothFirmware": "Bluetooth_V105",
        "note": "1.Wireless communication settings→Bluetooth settings→Enable\n2.Wireless communication settings→WiFi/Bluetooth connection→Connect to Wireless Remote→Add a device to connect to\n3.Gimbal operation: Swipt left from the main interface →Bluetooth setting→turn on camera control button→click the camera name to pairing\n4.Switching the camera to M mode(photo mode):      →Drive mode→Self-timer:10 sec/remote or Self-timer:2 sec\n5.Switching the camera to video mode:     →Remote control→Enable\n6.     →Power saving→Auto power off→Disable\n7.Please switch photo / video mode on camera manually."
    },
    {
        "brand": "Canon",
        "camera": "EOS M6 Mark Ⅱ",
        "controlFunction": "Bluetooth",
        "photo": "√",
        "video": "√",
        "blueToothTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "√",
        "focus": "×",
        "zoom": "×",
        "cameraFirmware": "1.1.1",
        "blueToothFirmware": "Bluetooth_V105",
        "note": "1.Wireless communication settings→Bluetooth settings→Enable\n2.Wireless communication settings→WiFi/Bluetooth connection→Connect to Wireless Remote→Add a device to connect to\n3.Gimbal operation: Swipt left from the main interface →Bluetooth setting→turn on camera control button→click the camera name to pairing\n4.Switching the camera to M mode(photo mode):      →Drive mode→Self-timer:10 sec/remote or Self-timer:2 sec/remote\n5.Switching the camera to video mode(M):     →Remote control→Enable\n6.     →Power saving→Auto power off→Disable\n7.Please switch photo / video mode on camera manually."
    },
    {
        "brand": "Canon",
        "camera": "EOS R5",
        "controlFunction": "Bluetooth",
        "photo": "√",
        "video": "√",
        "blueToothTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "√",
        "focus": "×",
        "zoom": "×",
        "cameraFirmware": "1.9.0",
        "blueToothFirmware": "Bluetooth_V105",
        "note": "1.Wireless communication settings→Bluetooth settings→Enable\n2.Wireless communication settings→WiFi/Bluetooth connection→Connect to Wireless Remote→Add a device to connect to\n3.Gimbal operation: Swipt left from the main interface →Bluetooth setting→turn on camera control button→click the camera name to pairing\n4.Switching the camera to M mode(photo mode):Single tap the Q button →Drive mode→Self-timer:10 sec/remote or Self-timer:2 sec/remote\n5.Switching the camera to video mode(M):     →Remote control→Enable\n6.     →Power saving→Auto power off→Disable\n7.Please switch photo / video mode on camera manually."
    },
    {
        "brand": "Nikon",
        "camera": "Z30",
        "controlFunction": "Bluetooth",
        "photo": "√",
        "video": "√",
        "blueToothTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "×",
        "focus": "×",
        "zoom": "×",
        "cameraFirmware": "1.10",
        "blueToothFirmware": "Bluetooth_V104",
        "note": "1.   →Wireless remote(ML-L7) options→Wireless remote control→On\n2.Gimbal operation: Swipt left from the main interface →Bluetooth setting→turn on camera control button→click the camera name to pairing\n3.Please switch photo / video mode on camera manually."
    }
]

export default data